// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b85551cd","703":"2daf3572","787":"6f2fdf72"}[chunkId] + ".chunk.js";
};